import React, { ReactNode, useEffect, useState } from 'react'
import Header from '../header/header.component';
import Footer from '../footer/footer.component';
import styles from './page.module.css'

export interface PageProps {
    title?: string,
    subtitle?: ReactNode,
    eyebrow?: string,
    width?: 'narrow' | 'default' | 'wide',
    children?: ReactNode
}

export default function Page({ title, subtitle, eyebrow, width = 'default', children }: PageProps) {
    return <div className={styles.shell}>
        <Header />
        <main className={`${styles.main} ${styles[width]}`}>
            {title && <section className={styles.hero}>
                {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
                <h1 className={styles.title}>{title}</h1>
                {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            </section>}
            {children}
        </main>
        <Footer />
        <BackToTop />
    </div>
}

function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return <button
        type='button'
        aria-label='Voltar ao topo'
        className={`${styles.backToTop} ${visible ? styles.backToTopVisible : ''}`}
        onClick={() => window.scrollTo({ top: 0 })}
        tabIndex={visible ? 0 : -1}
    >
        <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
            <path d='M12 19V5M5 12l7-7 7 7' />
        </svg>
    </button>
}
